import * as React from 'react';
import * as styles from './autoHeightTextarea.css';

export interface IAutoHeightTextareaProps {
  favoriteEntityId?: string; //TODO: поменять свойство на обязательное
  comment: string;
  onChange(event: React.SyntheticEvent<HTMLTextAreaElement>): void;
}

export class AutoHeightTextarea extends React.PureComponent<IAutoHeightTextareaProps, {}> {
  protected textarea: HTMLTextAreaElement | null;

  public componentDidMount(): void {
    if (this.textarea) {
      this.textarea.focus();

      const { scrollHeight } = this.textarea;

      this.textarea.style.height = `${scrollHeight}px`;
      this.textarea.style.minHeight = `${scrollHeight}px`;
    }
  }

  public render() {
    const { favoriteEntityId, comment } = this.props;

    return (
      <textarea
        id={`comment_${favoriteEntityId}`}
        ref={elem => {
          this.textarea = elem;
        }}
        rows={1}
        name="comment"
        onDrop={this.resize}
        onCut={this.resize}
        onPaste={this.resize}
        value={comment}
        onChange={this.onChange}
        className={styles['comment_textarea']}
      />
    );
  }

  private onChange = (event: React.SyntheticEvent<HTMLTextAreaElement>) => {
    this.resize(event);
    this.props.onChange(event);
  };

  private resize = ({ currentTarget }: React.SyntheticEvent<HTMLTextAreaElement>) => {
    currentTarget.style.minHeight = `auto`;
    currentTarget.style.height = 'auto';
    currentTarget.style.height = `${currentTarget.scrollHeight}px`;
    currentTarget.style.minHeight = `${currentTarget.scrollHeight}px`;
  };
}
